import { styled } from "styled-components";
import { useAtom,} from "jotai";
import { Text } from "@bracket/ui/components";
import { InteractiveElement, UIBase, FlexBox, } from "@bracket/ui/nodes";
import type { ListPosition, Strata, } from "@bracket/ui/types";
import { selections, type Selectable, } from "./atomic";
import type { MouseEvent, } from "react";
 


export declare type SelectableItemProps = {
	item: Selectable;
	parent: keyof typeof selections;
	position: ListPosition;
	onSelect?: ( event?: MouseEvent<HTMLDivElement>, item?: Selectable, ) => void;
}



export const SelectableItem = ({
	item,
	parent,
	position,
	onSelect,
}: SelectableItemProps) => {

	const [selection, setSelection] = useAtom(selections[parent]);
	const selected = selection.selected === item;

	const handleSelect = (event: MouseEvent<HTMLDivElement>) => {
		event.stopPropagation();
		event.preventDefault();
		onSelect?.(event, item);
		setSelection({ ...selection, selected: item, open: false,  });
	}

	return (
		<SelectItemContainer onClick={handleSelect} $selected={selected} $position={position} $strata="highest">
			<Text style={{ whiteSpace: "nowrap", }}>{item.label}</Text>
		</SelectItemContainer>
	)
}

const SelectItemContainer = styled(InteractiveElement).attrs({ $maxWidth: true })<{ $selected: boolean; $position?: ListPosition; $strata: Strata; }>`
	padding: 16px;
	box-shadow: 0px 10px 12px 0px rgba(0, 0, 0, 0.1);
	${({ $position }) => (
		$position === "first" ? "border-radius: 0px;" :
		$position === "middle" ? "border-radius: 0px;" :
		$position === "single" ? "border-radius: 0px 0px 8px 8px;" :
		$position === "last"  ? "border-radius: 0px 0px 8px 8px;" :
		"border-radius: 0px;"
	)}
`
